import { RegisterForm } from 'components/RegisterForm/Register';

const RegisterPage = () => {
  return (
    <div>
      RegisterPage
      <RegisterForm />
    </div>
  );
};

export default RegisterPage;
